export const formatDate = (date, tz = 'UTC') => {
  return new Date(date).toLocaleDateString(undefined, { timeZone: tz });
};

export const formatDateTime = (date, tz = 'UTC') => {
  return new Date(date).toLocaleString({}, { timeZone: tz });
};

export const formatDateTimeFriendly = (date, tz = 'UTC') => {
  const options = {
    timeZone: tz,
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  };

  return new Date(date).toLocaleString({}, options);
};

export const formatDateFriendly = (date, format = 'short', tz = 'UTC') => {
  const options = {
    weekday: format === 'long' ? 'long' : 'short',
    year: 'numeric',
    month: format === 'long' ? 'long' : 'short',
    day: 'numeric',
    timeZone: tz,
  };
  return new Date(date).toLocaleDateString({}, options);
};

export const formatMonthYear = (date, tz = 'UTC') => {
  return new Date(date).toLocaleDateString(undefined, { month: 'short', year: 'numeric', timeZone: tz });
};

export const formatTimeFriendly = (time, tz = 'UTC') => {
  const options = {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
    timeZone: tz,
  };
  return new Date(time).toLocaleTimeString({}, options);
};

// Shared date format for the CARE AI review tables (feedback + enhancement log).
export const formatReviewDate = (dateStr, tz = 'UTC') => {
  if (!dateStr) return '';
  return new Date(dateStr).toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    timeZone: tz,
  });
};

export const formatRelativeTime = (dateString, tz = 'UTC') => {
  const now = new Date();
  const date = new Date(dateString);
  const diffMs = now - date;
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);

  if (diffMins < 1) return 'Just now';
  if (diffMins < 60) return `${diffMins}m ago`;
  if (diffHours < 24) return `${diffHours}h ago`;
  if (diffDays < 7) return `${diffDays}d ago`;
  return date.toLocaleDateString(undefined, { timeZone: tz });
};
